<div class="search-component placeset-search">
  <div class="input-with-icon-left">
    <input
      #search
      autofocus
      [typeaheadAsync]="true"
      isAnimated="true"
      [optionsListTemplate]="customListTemplate"
      [(ngModel)]="selectedValue"
      [typeahead]="placeLists"
      [typeaheadMinLength]="0"
      typeaheadOptionsLimit="2000"
      [typeaheadWaitMs]="200"
      typeaheadOptionField="name"
      [typeaheadWaitMs]="200"
      class="form-control"
      placeholder="Search Custom Places"
      [disabled]="isLoadingResults"
    />
    <div class="input-icon">
      <i class="modus-icon material-icons">search</i>
    </div>
  </div>
</div>
<ng-template
  #customListTemplate
  let-matches="matches"
  let-query="query"
  let-typeaheadTemplateMethods
>
  <div class="overflow-hidden">
    <div
      class="card-header d-flex align-items-center border-0 user-select-none p-1 pl-2"
      style="height: 42px"
      (click)="(false); $event.stopPropagation()"
    >
      <button
        class="btn btn-icon-only btn-text-dark"
        *ngIf="itemLevel > 0"
        (click)="goBack()"
      >
        <i class="modus-icons">chevron_left</i>
      </button>
      <div
        class="w-100"
        (click)="itemLevel === 0 ? $event.stopPropagation() : goBack()"
      >
        <span class="text-gray-6 small m-0 p-2" style="font-weight: bold">
          {{ title }}</span
        >
      </div>
      <button
        class="btn btn-sm btn-primary"
        *ngIf="itemLevel > 0"
        [disabled]="selectedPlaceCount <= 0"
        (click)="addSelectedPlace()"
      >
        <span *ngIf="selectedPlaceCount <= 0">Select Place(s) to Add</span>
        <span *ngIf="selectedPlaceCount === 1"
          >Add {{ selectedPlaceCount }} Place</span
        >
        <span *ngIf="selectedPlaceCount > 1"
          >Add {{ selectedPlaceCount }} Places</span
        >
      </button>
    </div>
    <div class="list-container d-flex position-relative align-items-start">
      <ul
        class="list-group flex-shrink-0 position-relative"
        style="width: 100%"
      >
        <li
          class="list-group-item d-flex text-truncate align-items-center user-select-none border-left-0 border-right-0"
          *ngFor="let match of matches"
          [ngClass]="{
            disabled: match.item?.primary?.count === 0
          }"
          (click)="selectCustomPlace(match?.item); $event.stopPropagation()"
        >
          <div
            *ngIf="match.item?.primary?.iconpath"
            style="height: 24px; width: 24px"
          >
            <!-- <i
              *ngIf="match?.item.primary?.icon"
              class="modus-icons mr-2 mt-1 pb-2"
              style="font-size: large"
              tooltip="{{ match.item.primary?.toolTip }}"
              container="body"
              [adaptivePosition]="false"
              >{{ match.item?.primary?.icon }}</i
            > -->
            <img
              class="mr-2"
              style="height: 24px; width: 24px"
              [src]="match.item?.primary?.iconpath"
            />
          </div>
          <div
            *ngIf="match?.item.primary?.icon"
            class="custom-control custom-checkbox mr-2 mt-1 pb-2"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              [checked]="match?.item?.isSelected"
              class="custom-control-input"
              [id]="match?.item.id"
            />
            <label class="custom-control-label" for="customCheck-sm1"></label>
          </div>
          <div class="d-flex p-1 flex-column flex-grow-1 text-truncate">
            <div class="d-flex flex-row justify-content-between">
              <div class="text-truncate pr-1 w-100">
                <span class="{{ match.item?.primary?.textClass }}">
                  {{ match.item?.primary?.textValue }}
                </span>
              </div>
            </div>
            <div class="text-truncate">
              <span
                *ngIf="match.item?.secondary?.textValue"
                class="{{ match.item?.secondary?.textClass }}"
                >{{ match.item?.secondary?.textValue }}</span
              >
              <span
                *ngIf="match.item?.tertiary?.textValue"
                class="{{ match.item?.tertiary?.textClass }}"
                >{{ match.item?.tertiary?.textValue }}</span
              >
            </div>
          </div>
          <div class="d-flex flex-row justify-content-end">
            <ng-container *ngIf="match.item?.child; else second">
              <div *ngIf="match.item?.primary?.count">
                <span class="badge badge-pill badge-tertiary ml-auto mr-1">{{
                  match.item?.primary?.count
                }}</span>
              </div>
              <i class="modus-icons" *ngIf="match.item?.child">chevron_right</i>
            </ng-container>
            <ng-template #second>
              <i
                *ngIf="hasResult && places?.length"
                class="modus-icons mr-2 mt-1 list-group-item__item-control"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Show Location"
                style="font-size: large"
                (click)="showLocation(match?.item, $event)"
                >location</i
              >
            </ng-template>
          </div>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
